import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { createStore, applyMiddleware } from 'redux';
import  rootReducer  from './reducers'

import thunk from 'redux-thunk';

const logger = ({dispatch, getState}) => (next) =>(action) =>{
  next(action);
}

const store = createStore(rootReducer,applyMiddleware(logger,thunk));


ReactDOM.render(
  <React.StrictMode>
    <App 
      store={store}
    />
  </React.StrictMode>,
  document.getElementById('root')
);
